module.exports = __webpack_public_path__ + "img/P_FAQ02.7819781e.png";